// Die Reihenfolge der ersten drei Zeilen traegt das Hochfahren: der Polyfill, dann die
// Registrierung der Communication, dann erst die Komponente. Steht die Komponente davor, wird der
// StateManager konstruiert, bevor sein Token da ist, und furnhome startet mit einem weissen Bild.
import 'reflect-metadata';
import './composition-root';
import '@dh-software/furnhome-component';
import './index.sass';
import type { DhFurnhome } from '@dh-software/furnhome-component';

const furnhome = document.querySelector('dh-furnhome') as DhFurnhome;
furnhome.addEventListener('loaded', () => furnhome.setFirstNeededElements());
